import React from 'react';

export const SvgPhotoSizeSelectActual = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3h18c1 0 2 1 2 2v14c0 1-1 2-2 2H3c-1.1 0-2-.9-2-2V5c0-1 1-2 2-2zm5.12 9.99l-2.49 3.2c-.26.33-.02.81.39.82h11.99a.5.5 0 00.4-.8l-3.51-4.68c-.2-.27-.6-.27-.8-.01L11 15.51l-2.1-2.53a.5.5 0 00-.78.01z"
      fill="currentColor"
    />
  </svg>
);
